<template>
    <v-container>
        <!--LINEA
        <hr class="p2">-->
        <div id="curso1" style="margin-top: -5%; text-align: justify;">
            <h2>CURSO "Corrupción y Deforestación en Colombia: Una aproximación general al fenómeno"</h2>
            <p>
                Este curso, creado con el apoyo de la Oficina de las Naciones Unidas Contra la Droga y el Delito -UNODC para la Región Andina y el Cono Sur  en el marco del componente 
                anticorrupción del programa Territorios Forestales Sostenibles-TEFOS , busca profundizar el conocimiento sobre los vínculos entre la corrupción y delitos ambientales como 
                la deforestación en Colombia, a través de herramientas conceptuales y prácticas destinadas a servidores públicos, actores de sociedad civil, ciudadanía, academia y 
                sector privado del nivel nacional y territorial.
            </p>
            <h2>Información general del curso</h2>
            <p>                
                <ul>
                    <li><b>Duración:</b> 25-30 horas aproximadamente.</li>
                    <li><b>Modalidad:</b> curso virtual autogestionado, gratuito de acceso público previa inscripción.</li>
                    <li><b>Público Objetivo: </b>servidores públicos, organizaciones de sociedad civil, academia, sector privado y ciudadanía del nivel nacional y territorial</li>
                    <li>
                        <b>Módulos Temáticos: </b>
                        modulo introductorio con prueba de conocimientos ¿Qué tanto conozco sobre la corrupción y los delitos ambientales como la deforestación?<br> 
                        Módulo 1: corrupción y deforestación, aproximación a los conceptos y a su vínculo.<br>
                        Módulo 2: tipologías de corrupción alrededor de motores causantes de deforestación<br>
                        Módulo 3: estudio de casos para el análisis de tipologías de corrupción alrededor de motores causantes de deforestación.
                    </li>
                    <li><b>Certificación: </b>al finalizar el curso en su totalidad, el estudiante obtendrá un certificado simbólico de culminación exitosa del curso.</li>
                </ul>
            </p>
            <p>
                <i>
                    Desde el (día) (mes) de 2024 estará habilitado la primera cohorte del curso, en el cual la ciudadanía, los servidores públicos, los veedores ciudadanos y demás personas interesadas podrán inscribirse y realizar el curso. 
                </i><br><br>
                Clic aquí para acceder al curso<br>
                <a href="https://elearning.unodc.org.co/enrol/index.php?id=73" target="_blank">Corrupción y Deforestación en Colombia: Una aproximación general al fenómeno</a>
            </p>
            <p>
                <div class="d-flex justify-center align-center" style="flex-wrap: wrap;">
                    <v-img :src="require('@/assets/curso1.png')" max-height="170" max-width="500" contain ></v-img>
                    <v-img :src="require('@/assets/curso2.png')" max-height="170" max-width="500" contain ></v-img>
                    <v-img :src="require('@/assets/curso3.png')" max-height="170" max-width="500" contain ></v-img>
                </div>
            </p>
        </div>
    </v-container>
</template>

<script>
import axios from 'axios';
import SectionTitle from '@/components/SectionTitle.vue';

export default {
    components: {
        SectionTitle
    },
    data() {
        return {
            datos: [],
            dato: {
                oid: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                images: '',
                r_images: '',
                link: '',
                folder: '',
            },
            cards: [
                {
                    id: 1,
                    title: 'Corrupción y Deforestación en Colombia',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 1',
                    images: ['logo3.png'], 
                    link: 'https://elearning.unodc.org.co/enrol/index.php?id=73',
                    component: 'about',
                    destacado: 1,
                },
                {
                    id: 2,
                    title: 'Curso 2',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['logo3.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'about',
                    destacado: 1,
                },
                {
                    id: 3,
                    title: 'Curso 3',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 2Additional Info for Card 2Additional Info for CAdditional Info for Card 2Additional Info for Card 2Additional IAdditional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2nfo for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2ard 2Additional Info for Card 2Additional Info for Card 2Additional Info for Card 2',
                    images: ['logo3.png'],                    
                    chip: ['7:00 AM', '9:00 AM', '11:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'about',
                    destacado: 0,
                },
                {
                    id: 4,
                    title: 'Curso 4',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 4',
                    images: ['logo3.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'about',
                    destacado: 0,
                },
                {
                    id: 5,
                    title: 'Curso 5',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['logo4.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'about',
                    destacado: 0,
                },
                {
                    id: 6,
                    title: 'Curso 6',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['logo4.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    component: 'about',
                    destacado: 0,
                },
                {
                    id: 7,
                    title: 'Curso 7',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, consectetur adipiscing elit, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['logo4.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                    destacado: 0,
                },
            ],
            cardState: {},
            search: '',
        };  
    },/*
    mounted() {
      this.listar();
    },*/
    computed: {
        filtered() {
            return this.cards.filter(card =>
                card.title.toLowerCase().includes(this.search.toLowerCase())
            );
        },
    },
    methods: {
        // Obtener la lista de Categiries
        /*async listar() {
            try {
                const response = await axios.get('api/Categories/Listar');
                this.datos = response.data;

                // Ahora que tienes los datos, puedes mapearlos al formato que esperas para las tarjetas (cards)
                this.cards = this.datos.map(category => {
                    return {
                        id: category.oid,
                        title: category.title,
                        subtitle: category.subtitle,
                        description: category.description,
                        additionalInfo: category.additionalInfo,
                        images: ['fondo2.jpg'],   // Asegúrate de manejar el caso donde images es null o undefined
                        link: category.link,
                    };
                });
            } catch (error) {
                console.error(error);
            }
        },*/
        getImageSrc(filename) {
            return require(`../assets/${filename}`);
        },
        flipCard(cardId, isFlipped) {
            // Verificar si cardState[cardId] existe antes de acceder a sus propiedades
            if (this.cardState[cardId]) {
                this.$set(this.cardState[cardId], 'isFlipped', isFlipped);
            } else {
                // Si no existe, inicialízalo con isFlipped
                this.$set(this.cardState, cardId, { isFlipped });
            }
        },
        openLink(link) {
            window.open(link, '_blank');
        },
    },
    created() {
        // Initialize cardState for each card
        this.cards.forEach(card => {
            this.$set(this.cardState, card.id, { isFlipped: false });
        });
    },
    
};
</script>
<style>
    .v-card {
        perspective: 1000px;
        transition: transform 0.5s;
    }

    .v-card.is-flipped {
        transform: rotateY(180deg);
    }

    .custom-h1 {
        font-size: 2.5em; /* Puedes ajustar el tamaño según tus necesidades */
        font-weight: bold; /* Otras propiedades de estilo si es necesario */
    }

    .custom-h3 {
        font-size: 1.5em; /* Puedes ajustar el tamaño según tus necesidades */  
    }
    p {
        /* font-family: 'Heebo', sans-serif !important; */
        font-family: 'Roboto' !important;
        font-size: 14px;     
        line-height: 1.6em;
    }
    h1 {
        font-family: 'Heebo', sans-serif;
        /* font-family: 'Heebo', sans-serif; */
    }
    h2 {
        /* font-family: 'Heebo', sans-serif; */
        font-family: 'Roboto' !important;
        font-size: 18px;
    }
    h3 {
        font-family: 'Heebo', sans-serif;
    }
    .p1{
        font-size: 17px; 
        color: rgb(15, 135, 201); 
        line-height: 1em;
    }
    .p2{
        border: none;
        border-top: 2px solid #000;
        margin: 20px 0;
    }
    .bannerNormatividad {
        background-image: url(../assets/banner1.jpg);
        background-size: cover;
        background-position: center;
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        color: white;
        font-size: 2rem;
    }
</style>